import { FastshiftDashboardPageTemplate } from "../../templates/dashboard/fastshift-dashboard-page/src";

export const FastshiftDashboardPage = () => <FastshiftDashboardPageTemplate />;
